import classNames from 'classnames'
import Dropdown from '../dropdown'
import DateRange from '../dateRange'
import CustomSelect from '../customSelect'
import {CloseIcon, FilterIcon} from '../../../icons'
import {SimpleBlueButton} from '../button'
import TextHelper from '../../../utils/text'

const FiltersDropdown = ({
    text,
    isDarkMode,
    filterSettings,
    setFilterSettings,
    filterConfig,
    rangeSelected,
    onChangeDateRange,
    onApplyFilters,
    onResetFilters,
    customAfterLabel,
    onClearCustomAfterLabel,
    dropdownMenuRef,
    isFilterButtonActive,
    onOpenMenu,
    onCloseMenu
}) => {
    const getFilterButtons = () => {
        return <div className="buttons w-100 d-flex gap-1 mt-1">
            <SimpleBlueButton onClick={onResetFilters} outline={true}>{text.reset}</SimpleBlueButton>
            <SimpleBlueButton onClick={onApplyFilters}>{text.apply}</SimpleBlueButton>
        </div>
    }

    const renderers = {
        select: (config) => (
            <div className="field-wrapper">
                <CustomSelect
                    {...config.props}
                    value={filterSettings[config.key]}
                    onChange={(_, value) =>
                        setFilterSettings((prev) => ({...prev, [config.key]: value}))
                    }
                />
                {config.props?.customAfter && customAfterLabel && (
                    <span
                        className={classNames('resource-name-label', {dark: isDarkMode})}
                        title={customAfterLabel}
                    >
                        {TextHelper.textLengthChecker(customAfterLabel, 20)}
                        <span onClick={onClearCustomAfterLabel} className="clear-icon">
                            <CloseIcon />
                        </span>
                    </span>
                )}
            </div>
        ),
        date: (config) => (
            <DateRange
                placeholder={rangeSelected ? text.range_selected : text.choose_date}
                state={filterSettings[config.key]}
                onChange={onChangeDateRange}
            />
        ),
        input: (config) => (
            <input
                type="text"
                className="filter-input"
                value={filterSettings[config.key] || ''}
                placeholder={config.props?.placeholder || ''}
                onChange={(e) =>
                    setFilterSettings((prev) => ({...prev, [config.key]: e.target.value}))
                }
            />
        )
    }

    const renderFilter = (config) => renderers[config.type]?.(config) || null

    return (
        <Dropdown
            onOpen={onOpenMenu}
            onClose={onCloseMenu}
            menuButton={
                <button className={classNames('filter-button', {
                    active: isFilterButtonActive
                })}>
                    <FilterIcon />
                    {text.filters}
                </button>
            }
            innerRef={dropdownMenuRef}
        >
            <div className={classNames('incident-filter', {
                dark: isDarkMode
            })}>
                <div className={classNames('selects', {
                    dark: isDarkMode
                })}>
                    {filterConfig.map((config) => (
                        <div className={config.className} key={config.key} id={config?.id || ''}>
                            <span className="label">{config.label}</span>
                            {renderFilter(config)}
                        </div>
                    ))}
                    {getFilterButtons()}
                </div>
            </div>
        </Dropdown>
    )
}

export default FiltersDropdown
